
	import Vue from "vue"
	import Component from "vue-class-component"
	import Page from "custom/Page.vue"
	import Card from "@components/panel/Card.vue"
	import IcsButton from "custom/ui/IcsButton.vue"
	import IcsInput from "custom/ui/IcsInput.vue"
	import LoginForm from "custom/login/LoginForm.vue"
	import { userModule } from "store/modules"
	import Loader from "custom/Loader.vue"

	@Component({
		components: {
			Page,
			Card,
			IcsInput,
			IcsButton,
			LoginForm,
			Loader
		}
	})
	export default class Login extends Vue {
		@userModule.Getter isUserLoading!: boolean

		readonly baseTranslationKey = "login"

		beforeMount(): void {
			localStorage.removeItem("LOGOUT")
		}
	}
